import React from 'react';
import './WhyOffshoreAdvisory.css'
import Hero from '../../../../components/home/Hero/Hero';
import { useTranslation } from 'react-i18next';
import whiteArrowIcon from '../../../../assets/images/Home/whiteArrow.svg'
import { Link } from 'react-router-dom';
import useLangLink from "../../../../utils/useLangLink";
import Discover from '../../../../components/Discover/Discover';
import OherPractices from '../../../../components/OtherPractices/OherPractices';
import ContactFormWithBackground from '../../../../components/ContactFormWithBackgroundGray/ContactFormWithBackground';
import SEO from "../../../../utils/SEO";



function WhyOffshoreAdvisory() {
    const { t } = useTranslation();
    const lp = useLangLink();
    const tp = (k, d) => t(`pages.why-offshore-advisory.${k}`, d);
    const breadcrumbs = [
        { name: tp('breadcrumb.home', 'Home'), link: '/' },
        { name: tp('breadcrumb.self', 'Why Offshore Advisory'), link: '/why-offshore-advisory' },
    ];
    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/why-offshore-advisory"
            />

            <Hero breadcrumbs={breadcrumbs} contentCenter={true} pretitle={tp('hero.pretitle')} title={tp('hero.title')} descr={tp('hero.descr')} backgroundImg='whyOffshoreHeader'/>
            <section
                className='about-section section'
            >
                
                <div className='why-offshore-background'>
                    <div className='why-choose-us-container'>
                        <div className='why-choose-us-left'>
                            <h2 className='why-choose-us-title'>
                                {tp('whyChoose.title')}
                            </h2>
                            <span className='why-choose-us-sub-title'>
                                {tp('whyChoose.subtitle')}
                            </span>
                        </div>
                        <div className='why-choose-us-right'>
                        {(tp('whyChoose.items', { returnObjects: true }) || []).map((it, i) => (
                            <div className='why-choose-us-item' key={i}>
                                <span className='why-choose-us-item-point'>{`(0${i + 1})`}</span>
                                <h3 className='why-choose-us-item-title'>{it.title}</h3>
                                <div className='why-choose-us-item-descr' dangerouslySetInnerHTML={{ __html: it.descr }} />
                            </div>
                        ))}
                    
                        </div>
                    </div>
                </div>
                <div className='makes-us-different-container'>
                    <h2 className='makes-us-different-title'>
                        {tp('different.title')}
                    </h2>
                    <div className='makes-us-different-row'>
                        <div className='makes-us-different-upper'>
                            <div className='makes-us-different-upper-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>{tp('different.items.0.title')}</h3>
                                </div>
                                <p className='upper-item-descr'>
                                    {tp('different.items.0.descr')}
                                </p>
                            </div>
                            <div className='makes-us-different-upper-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>{tp('different.items.1.title')}</h3>
                                </div>
                                <p className='upper-item-descr'>
                                    {tp('different.items.1.descr')}
                                </p>
                            </div>
                            <div className='makes-us-different-upper-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>{tp('different.items.2.title')}</h3>
                                </div>
                                <p className='upper-item-descr'>
                                    {tp('different.items.2.descr')}
                                </p>
                            </div>
                        </div>
                        <div className='makes-us-different-bottom'>
                            <div className='makes-us-different-bottom-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>{tp('different.items.3.title')}</h3>
                                </div>
                                <p className='upper-item-descr'>
                                    {tp('different.items.3.descr')}
                                </p>
                            </div>
                            <div className='makes-us-different-bottom-item'>
                                <div className='upper-item-header-wrapper'>
                                    <div className='square-item'>

                                    </div>
                                    <h3 className='upper-item-header-title'>{tp('different.items.4.title')}</h3>
                                </div>
                                <p className='upper-item-descr'>
                                    {tp('different.items.4.descr')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ready-to-get-started-background'>
                    <div className='ready-to-get-started-content'>
                        <h2 className='ready-to-get-started-title'>
                            {tp('ready.title')}
                        </h2>
                        <p className='ready-to-get-started-descr'>
                            {tp('ready.descr')}
                        </p>
                        <div className='ready-to-get-started-btn'>
                            <Link to={lp('/newsletter')} >
                                {tp('ready.button')}
                                <img src={whiteArrowIcon} alt="" />
                            </Link>
                        </div>
                    </div>
                </div>
                <Discover />
                <OherPractices />
                <ContactFormWithBackground />
            </section>
            {/* <Footer /> */}
        </main>
    );
}

export default WhyOffshoreAdvisory;
